module.exports = __webpack_public_path__ + "img/tiktok-logo.216675e2.svg";